export type NoResultsHint = "add" | "unlock" | "ask-admin" | null;

export const noResultsHint = (state: {
  canAdd: boolean;
  isShiftLocked: boolean;
  canToggleLock: boolean;
}): NoResultsHint => {
  if (!state.canAdd) return null;
  if (!state.isShiftLocked) return "add";

  return state.canToggleLock ? "unlock" : "ask-admin";
};
